import { memo, useState } from 'react'

import { Text, Icon, AdvancedTooltip } from 'common-components'
import VelocityIcon from 'assets/svgr-icons/Velocity.svg'

import { addXToValue } from './utils'
import * as Styled from './styled'
import { TTS_BULK_DEFAULT_SPEED, TTS_DEFAULT_SPEED } from 'consts/tts'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

interface IProps {
  toggleVelocityContent: () => void
  ttsSpeed: number | string
  isBulkMode?: boolean
  scrollableParentRef?: React.RefObject<HTMLDivElement | null>
}

const TtsSpeakerVelocityToggler: React.FC<IProps> = (props: IProps) => {
  const {
    toggleVelocityContent,
    ttsSpeed,
    isBulkMode = false,
    scrollableParentRef
  } = props
  const isDefaultValue = ttsSpeed === TTS_BULK_DEFAULT_SPEED
  const _ttsSpeed = isDefaultValue ? TTS_DEFAULT_SPEED : ttsSpeed

  const parsedValue = addXToValue(_ttsSpeed as number)

  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement | null>(null)

  const TtsVelocityTogglerWrapper = isBulkMode
    ? Styled.BulkModeVelocityTogglerWrapper
    : Styled.SingleItemVelocityTogglerWrapper

  const TtsVelocityTogglerContainer = isBulkMode
    ? Styled.BulkModeTogglerContainer
    : Styled.SingleItemTogglerContainer

  return (
    <TtsVelocityTogglerWrapper
      onClick={toggleVelocityContent}
      ref={setWrapperRef}
    >
      <TtsVelocityTogglerContainer>
        {isBulkMode ? (
          ttsSpeed !== TTS_BULK_DEFAULT_SPEED ? (
            <Text type="h4" color="secondarySemiDark">
              {parsedValue}
            </Text>
          ) : (
            <Icon
              icon={<VelocityIcon />}
              customSize={20}
              color="secondarySemiDark"
            />
          )
        ) : (
          <>
            <Icon
              icon={<VelocityIcon />}
              customSize={12}
              color="secondarySemiDark"
            />
            <Text type="h4" color="secondarySemiDark" lineHeight="12px">
              {parsedValue}
            </Text>
          </>
        )}
        <AdvancedTooltip
          tooltipText={
            isBulkMode ? translate(T.SPEED) : translate(T.CHANGE_SPEED)
          }
          tooltipPosition="top"
          btnRef={{ current: wrapperRef }}
          scrollableParentRef={scrollableParentRef}
        />
      </TtsVelocityTogglerContainer>
    </TtsVelocityTogglerWrapper>
  )
}
export default memo(TtsSpeakerVelocityToggler)
